var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfirmButton } from '../commons';
import { NationalAccountContext } from '../../../../../contexts';
import { mainPageBlurb } from '../../../../../constants/NationalAccount';
import { setOverlayEvent } from '../../../../../utils/analytics';
export var NotEnrolledSummary = function () {
    var _a = useContext(NationalAccountContext), setShowModal = _a.setShowModal, setValidResponseState = _a.setValidResponseState, isMobile = _a.isMobile;
    var sectionClasses = classNames('sui-flex sui-flex-col sui-justify-between', {
        'sui-align-center': isMobile,
        'sui-align-start': !isMobile,
    });
    return (React.createElement("div", { className: sectionClasses },
        React.createElement("div", { className: "sui-py-6 md:sui-w-5/6 sui-text-base lg:sui-text-lg" },
            React.createElement("p", null, mainPageBlurb)),
        React.createElement("div", null,
            React.createElement(ConfirmButton, { confirmBlurb: "Learn More", disabled: false, cb: function () {
                    setShowModal(true);
                    setOverlayEvent('pricing benefits national account incentives');
                    setValidResponseState(function (prevState) {
                        return __assign(__assign({}, prevState), { enrollState: true });
                    });
                } }))));
};
